import type { ComplexAttributeConverter } from "lit";

export type EnrollmentStageRoutes = Readonly<Record<string, string>>;

export const enrollmentStageRoutesConverter: ComplexAttributeConverter<EnrollmentStageRoutes> = {
    fromAttribute(value: string | null): EnrollmentStageRoutes {
        if (!value?.trim()) return Object.freeze({});
        try {
            const parsed: unknown = JSON.parse(value);
            if (!parsed || typeof parsed !== "object" || Array.isArray(parsed))
                return Object.freeze({});
            return Object.freeze(
                Object.fromEntries(
                    Object.entries(parsed).filter(
                        (entry): entry is [string, string] =>
                            entry[0].trim().length > 0 &&
                            typeof entry[1] === "string" &&
                            entry[1].trim().length > 0,
                    ),
                ),
            );
        } catch {
            return Object.freeze({});
        }
    },
    toAttribute(value: EnrollmentStageRoutes): string | null {
        return Object.keys(value).length > 0 ? JSON.stringify(value) : null;
    },
};

export function resolveEnrollmentStageRoute(
    routes: EnrollmentStageRoutes,
    stage: { readonly id: string; readonly kind: string },
): string {
    return routes[stage.id]?.trim() ?? routes[`kind:${stage.kind}`]?.trim() ?? "";
}

export function isCurrentBrowserRoute(route: string): boolean {
    if (!route.trim() || typeof window === "undefined") return false;
    const target = new URL(route, window.location.href);
    return (
        target.origin === window.location.origin &&
        target.pathname === window.location.pathname &&
        (!target.hash || target.hash === window.location.hash)
    );
}
